module.exports = __webpack_public_path__ + "img/letter.a301e8a7.png";